export default __webpack_public_path__ + "static/media/head-bee.530146fe.png";